"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var time_1 = require("../../common/helpers/time");
var AdminCoursesController = /** @class */ (function () {
    function AdminCoursesController($state, CoursesModel, courseTypes, LocationsModel, UsersModel, ClassroomsModel, VueStoreFactory) {
        var _this = this;
        this.$state = $state;
        this.maxSize = 10;
        this.currentPage = 1;
        this.loading = true;
        this.CoursesModel = CoursesModel;
        this.LocationsModel = LocationsModel;
        this.UsersModel = UsersModel;
        this.ClassroomsModel = ClassroomsModel;
        this.VueStoreFactory = VueStoreFactory;
        this.pageChanged = this.pageChanged.bind(this);
        this.search = this.search.bind(this);
        this.getCourses = this.getCourses.bind(this);
        this.getClassrooms = this.getClassrooms.bind(this);
        this.getInstructors = this.getInstructors.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
        this.viewCourse = this.viewCourse.bind(this);
        this.courseTypeOptions = courseTypes;
        this.courseTypeOptions.unshift({ 'name': 'All' });
        this.instructors = [];
        this.classrooms = [];
        this.locations = [];
        this.searchData = {
            paginate: true,
            end_date: "",
            start_date: "",
            page: 1
        };
        this.setup().then(function (res) {
            _this.loading = false;
        }).catch(function (Error) {
            _this.loading = false;
        });
    }
    AdminCoursesController.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var courses, locations, classrooms, instructors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCourses()];
                    case 1:
                        courses = _a.sent();
                        return [4 /*yield*/, this.LocationsModel.getLocations()];
                    case 2:
                        locations = _a.sent();
                        this.locations = locations;
                        this.locations.unshift({ 'name': 'All' });
                        return [4 /*yield*/, this.getClassrooms(null, true)];
                    case 3:
                        classrooms = _a.sent();
                        return [4 /*yield*/, this.getInstructors(null, true)];
                    case 4:
                        instructors = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminCoursesController.prototype.viewCourse = function (course) {
        // This makes sure that when viewing a single course from this screen, the first classdate is selected
        if (course.classes.length > 0) {
            var data = {
                id: course.id,
                date: course.date,
                class_id: course.classes[0].id,
                start: (0, time_1.dateTimeStringToDate)(course.classes[0].start).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }),
                end: (0, time_1.dateTimeStringToDate)(course.classes[0].end).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
            };
            data.date = (0, time_1.dateStringToDate)(course.date).toLocaleDateString();
            this.VueStoreFactory.dispatch('SET_VIEW_COURSE', data);
        }
        this.$state.go('drivecoach.admin.courses.view', { 'courseId': course.id });
    };
    AdminCoursesController.prototype.getCourses = function () {
        var _this = this;
        return this.CoursesModel.get().then(function (response) {
            _this.courses = response.courses.data.map(_this.formatCourses);
            _this.totalItems = response.courses.total;
        });
    };
    AdminCoursesController.prototype.pageChanged = function () {
        var _this = this;
        this.searchData.page = this.currentPage;
        return this.CoursesModel.search(this.searchData).then(function (response) {
            _this.courses = response.courses.data.map(_this.formatCourses);
            _this.totalItems = response.courses.total;
        });
    };
    AdminCoursesController.prototype.formatCourses = function (course) {
        var timeMoment = (0, moment_1.default)(course.time, 'H:mm:ss');
        course.time = timeMoment.format('h:mm A');
        course.end = timeMoment
            .add(parseInt(course.duration), 'm')
            .format('h:mm A');
        return course;
    };
    AdminCoursesController.prototype.search = function () {
        var _this = this;
        this.loading = true;
        this.searchData.page = 1;
        return this.CoursesModel.search(this.searchData).then(function (response) {
            _this.courses = response.courses.data.map(_this.formatCourses);
            _this.totalItems = response.courses.total;
            _this.currentPage = 1;
            _this.loading = false;
        }).catch(function (Error) {
            _this.loading = false;
        });
    };
    AdminCoursesController.prototype.getInstructors = function (name, all, location) {
        var _this = this;
        if (name === void 0) { name = null; }
        if (all === void 0) { all = false; }
        if (location === void 0) { location = null; }
        if (name === null && all === false) {
            return;
        }
        this.loading = true;
        var params = {
            'overrideInstructorSettings': this.overrideInstructorSettings
        };
        return this.UsersModel.searchInstructors(params).then(function (response) {
            _this.instructors = response.instructors;
            _this.instructors.unshift({ 'fullname': 'All' });
            _this.loading = false;
            return response.instructors;
        }).catch(function (error) {
            _this.loading = false;
            return error;
        });
    };
    AdminCoursesController.prototype.getClassrooms = function (name, all, location) {
        var _this = this;
        if (name === void 0) { name = null; }
        if (all === void 0) { all = false; }
        if (location === void 0) { location = null; }
        this.busy = true;
        return this.ClassroomsModel.search({}).then(function (response) {
            _this.classrooms = response.classrooms;
            _this.classrooms.unshift({ 'name': 'All' });
            _this.loading = false;
            return response.classrooms;
        }).catch(function (error) {
            _this.loading = false;
            return error;
        });
    };
    AdminCoursesController.prototype.updateEndDate = function (newDate) {
        this.searchData.end_date = newDate.selected[0];
    };
    AdminCoursesController.prototype.updateStartDate = function (newDate) {
        this.searchData.start_date = newDate.selected[0];
    };
    return AdminCoursesController;
}());
AdminCoursesController.$inject = ['$state', 'CoursesModel', 'courseTypes', 'LocationsModel', 'UsersModel', 'ClassroomsModel', 'VueStoreFactory'];
exports.default = AdminCoursesController;
